import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { FileHistoryItems } from 'src/app/interfaces/file.interface';
import { FoldersResponseInner } from '../../swagger-api';
import { fileHistoryMock } from './files.mock';

@Injectable({
  providedIn: 'root',
})
export class FileDetailsService {
  public fileHistory: FileHistoryItems[] = [];
  private fileHistoryChanges$: Subject<FileHistoryItems[]> = new Subject<FileHistoryItems[]>();

  private fileContent: FoldersResponseInner;

  public set fileDetails(fileDetails: FoldersResponseInner) {
    this.fileContent = fileDetails;
  }

  public get onFileHistoryChanged(): Observable<FileHistoryItems[]> {
    return this.fileHistoryChanges$.asObservable();
  }

  public fetchFileHistory(): void {
    this.fileHistory = fileHistoryMock.items;
    this.fileHistoryChanges$.next(this.fileHistory);
  }
}
